<template>
	<div class="announcement-box">
		<div class="announcement-icon">
			<i class="fa-regular fa-triangle-exclamation"></i>
		</div>
		<div class="announcement-content">
			<h4 class="announcement-title" v-if="announcement.title">{{ announcement.title }}</h4>
			<p class="announcement-text" v-if="announcement.content">{{ announcement.content }}</p>
		</div>
		<button type="button" class="announcement-close" @click.prevent="dismiss">
			<i class="fa-regular fa-xmark"></i>
		</button>
	</div>
</template>

<script>
	export default {
		name: "AnnouncementBox",
		props: ['announcement'],
		methods: {
			dismiss() {
				this.$store.commit('REMOVE_ANNOUNCEMENT', this.announcement);
			},
		},
	}
</script>

<style scoped lang="scss">
	.announcement-box {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 12px;
		padding: 14px 38px 14px 14px;
		border-radius: 8px;
		text-align: left;
		color: var(--white-color, $whiteColor);
		background: var(--background-color, $backgroundColor);
		border: 1px solid var(--primary-color);
		border-left-width: 4px;

		.announcement-icon {
			flex: 0 0 auto;
			margin-top: 1px;
			font-size: 20px;
			line-height: 1;
			color: $errorColor;
		}

		.announcement-content {
			flex: 1 1 auto;
			min-width: 0;
		}

		.announcement-title {
			margin: 0 0 4px;
			font-size: 14px;
			font-weight: 700;
			color: inherit;
		}

		.announcement-text {
			margin: 0;
			font-size: 12px;
			font-weight: 400;
			line-height: 1.4;
			opacity: .85;
		}

		.announcement-close {
			position: absolute;
			top: 10px;
			right: 12px;
			padding: 0;
			background: transparent;
			border: none;
			color: inherit;
			font-size: 15px;
			line-height: 1;
			cursor: pointer;
			opacity: .7;
			transition: $animationDefaultDuration;

			&:hover {
				opacity: 1;
			}
		}
	}
</style>
